import { apiRequest } from './apiUtils';
import { GoogleMapsSearchResult } from '@foodfluence/shared';

/** Nominatim search result shape (OpenStreetMap) */
export interface SearchResult {
  display_name: string;
  lat: string;
  lon: string;
  address: {
    city?: string;
    town?: string;
    county?: string;
    village?: string;
    state?: string;
    country?: string;
    postcode?: string;
  };
}

/**
 * Geocodes a postal code using backend (Google Maps API)
 */
export const geocodePostalCode = async (
  postalCode: string,
  country: string
): Promise<GoogleMapsSearchResult[]> => {
  if (!postalCode.trim() || !country.trim()) {
    return [];
  }
  return apiRequest<GoogleMapsSearchResult[]>({
    method: 'POST',
    endpoint: '/location/geocode-postal',
    data: { postalCode, country }
  });
};

/**
 * Fetches country name suggestions for autocomplete (via Node -> Flask -> Google API).
 */
export const getCountrySuggestions = async (inputText: string): Promise<string[]> => {
  const data = await apiRequest<{ suggestions: string[] }>({
    method: 'POST',
    endpoint: '/location/get-country-suggestions',
    data: { inputText },
  });
  return data?.suggestions ?? [];
};

/**
 * Reverse geocodes coordinates using backend proxy to Nominatim
 */
export const reverseGeocode = async (lat: number, lng: number): Promise<{
  address?: {
    country?: string;
    city?: string;
    town?: string;
    county?: string;
    village?: string;
    state?: string;
    postcode?: string;
  };
}> => {
  const data = await apiRequest<{
    address?: {
      country?: string;
      city?: string;
      town?: string;
      county?: string;
      village?: string;
      state?: string;
      postcode?: string;
    };
  }>({
    method: 'GET',
    endpoint: `/location/reverse?lat=${lat}&lon=${lng}`
  });
  return data ?? { address: {} };
};
